import moment from 'moment'
import {
  CardMeta,
  CardMetaGrid,
  ManagementCard,
  ManagementCardAction,
  ManagementCardList,
} from 'components/ManagementCard'
import { DATE_FORMAT } from '../../constants'
import { aiKnowledgeStrings } from '../../constants/strings'
import type { TDifyKnowledgeDocument } from '../../api/difyKnowledge'

type DocumentsCardListProps = {
  documents: TDifyKnowledgeDocument[]
  loading: boolean
  selectedDocumentId: string | null
  deletePending: boolean
  onSelect: (documentId: string) => void
  onDelete: (documentId: string) => void
  className?: string
}

export function DocumentsCardList({
  documents,
  loading,
  selectedDocumentId,
  deletePending,
  onSelect,
  onDelete,
  className,
}: DocumentsCardListProps) {
  return (
    <ManagementCardList
      loading={loading}
      isEmpty={documents.length === 0}
      loadingMessage={aiKnowledgeStrings.loading}
      emptyMessage={aiKnowledgeStrings.emptyDocuments}
      className={className}
    >
      {documents.map((doc) => (
        <li key={doc.id}>
          <ManagementCard
            onClick={() => onSelect(doc.id)}
            ariaLabel={doc.name}
            className={
              selectedDocumentId === doc.id ? 'bg-accent-soft/40' : undefined
            }
            title={doc.name}
            actions={
              <ManagementCardAction
                tone="danger"
                disabled={deletePending}
                onClick={() => {
                  if (window.confirm(aiKnowledgeStrings.deleteConfirm)) {
                    onDelete(doc.id)
                  }
                }}
              >
                {aiKnowledgeStrings.delete}
              </ManagementCardAction>
            }
          >
            <CardMetaGrid>
              <CardMeta
                label={aiKnowledgeStrings.table.createdAt}
                value={
                  doc.createdAt
                    ? moment(doc.createdAt).format(`${DATE_FORMAT} HH:mm`)
                    : '-'
                }
              />
              <CardMeta
                label={aiKnowledgeStrings.table.indexingStatus}
                value={doc.indexingStatus ?? '-'}
              />
            </CardMetaGrid>
          </ManagementCard>
        </li>
      ))}
    </ManagementCardList>
  )
}
